import {
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const ENTER_EMAIL_STEP: AuthStepDefinition = {
  id: AuthStepId.ENTER_EMAIL,
  route: AuthStepRoute.Email,
  back: null,
  next: {
    [AuthFlowId.Login]: {
      [AuthTransitionKey.Default]: AuthStepId.CONFIRM_EMAIL,
    },
    [AuthFlowId.Registration]: {
      [AuthTransitionKey.Default]: AuthStepId.CONFIRM_EMAIL,
    },
  },
};
